import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/60b46053ebf928b508f97a6acfab50b4.jpg"
          alt="Logistics Center"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#E67E50]/40 via-[#3D2817]/30 to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="max-w-2xl">
          <h1 className="text-7xl md:text-8xl font-bold text-white leading-tight mb-8">
            LOGISTICS<br />
            THAT MOVES<br />
            YOUR BUSINESS
          </h1>
          <Link 
            to="/privacy-policy"
            className="inline-flex items-center gap-3 px-8 py-4 bg-[#F4E8D8]/90 text-[#3D2817] text-sm font-semibold rounded-full hover:bg-[#F5A962] hover:text-white transition-all cursor-pointer whitespace-nowrap"
          >
            Explore Services
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10">
        <div className="text-white text-[12rem] font-bold opacity-20 leading-none pb-8 px-6">
          NEXT PHASE
        </div>
      </div>
    </section>
  );
}
